import { render, staticRenderFns } from "./select-local.vue?vue&type=template&id=e5aa0c3a&"
import script from "./select-local.vue?vue&type=script&lang=js&"
export * from "./select-local.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5aa0c3a')) {
      api.createRecord('e5aa0c3a', component.options)
    } else {
      api.reload('e5aa0c3a', component.options)
    }
    module.hot.accept("./select-local.vue?vue&type=template&id=e5aa0c3a&", function () {
      api.rerender('e5aa0c3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/own-component/select-local.vue"
export default component.exports